import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MomentModule } from 'angular2-moment';

// Rutas
import { APP_ROUTING } from './app.route';

// Services
import { InformacionService } from './services/informacion.service';
import { ValidationService } from './services/validation.service';
import { ContactosService } from './services/contactos.service';

// pipes
import { KeysPipe } from './pipes/keys.pipe';
import { SinfotoPipe } from './pipes/noimage.pipe';

import { AppComponent } from './app.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { HomeComponent } from './components/home/home.component';
import { NosotrosComponent } from './components/nosotros/nosotros.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { ContactoComponent } from './components/contacto/contacto.component';
import { ServiciosComponent } from './components/servicios/servicios.component';
import { ControlMessagesComponent } from './components/shared/control-messages/control-messages.component';
import { ExitosoComponent } from './components/contacto/exitoso.component';
import { ListarComponent } from './components/contacto/listar.component';
import { HttpClientModule } from '@angular/common/http';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HomeComponent,
    NosotrosComponent,
    FooterComponent,
    ContactoComponent,
    ServiciosComponent,
    ControlMessagesComponent,
    ExitosoComponent,
    KeysPipe,
    SinfotoPipe,
    ListarComponent
  ],
  imports: [
    BrowserModule,
    APP_ROUTING,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule
  ],
  providers: [
    InformacionService,
    ValidationService,
    ContactosService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/app.module.ts